export default "__VITE_ASSET__BYYXrj09__"